import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        form: css`
            ${custom.stepElementPadding};
            padding-right: 0;
        `,
        buttons: css`
            ${common.flexJustityAlignCenter};
        `,
        button: css`
            margin: 0 50px;
            width: auto !important;
            padding: 0 50px;
            ${custom.button};
        `,
        inactive: css`
            background-color: ${theme.palette.primary[50]};
        `,
        summaryView: css`
            display: flex;
            flex-direction: column;
        `,
    }
}

export default styles
